import * as actions from './measurementTemplate/actions'
import * as mutations from './measurementTemplate/mutations'
import * as getters from './measurementTemplate/getters'

import { dataProps } from './measurementTemplate/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps)),
    item_type: 0//tailoring product, fabric, ready to wear, raw material, asset
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/measurementTemplate.js